import { Component, OnInit, Input } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { WelcomeBanner } from 'src/app/models/uimodels/welcomeBanner';
import { Multilingual } from 'src/app/services/multilingual';
import { TranslaterService } from 'src/app/services/translater.service';
import { WelcombannerService } from 'src/app/services/welcombanner.service';

@Component({
  selector: 'app-welcome-banner',
  templateUrl: './welcome-banner.component.html',
  styleUrls: ['./welcome-banner.component.scss']
})
export class WelcomeBannerComponent implements OnInit {
  @Input() bgImage!: string;
  welcomeBannerData!: WelcomeBanner;
  languageDir = 'ltr';
  langObj: any = {};
  lang!:any;
  constructor(private welcomeBannerService: WelcombannerService,  public translater: TranslaterService,
    public translate: TranslateService) { }

  ngOnInit(): void {
    this.welcomeBannerService.getWelcomeBannerdata().subscribe((data: WelcomeBanner) => {
      this.welcomeBannerData = data;
    });

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ?  this.languageDir = 'rtl' :  this.languageDir = 'ltr';this.getLangWords();});

    this.getLangWords();
 
  }
  public getLangWords() {
    const key = {
      ModuleId: 0,
      PageId: 0,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
    
      this.langObj = res.tagList;
    });
  }
  getTransalatedValue(value:string){
    let val;
    if(this.langObj.length > 0){
      val= this.langObj?.find(f => f.tagName === value)
    }
    return val?.translatedValue;
 }

}
